module.exports = __webpack_public_path__ + "img/cast.f25ca003.svg";